import { FormControl, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[floValidIf]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: ValidIfDirective, multi: true },
    ],
})
export class ValidIfDirective {
    private formControl: FormControl;
    private _floValidIf: boolean;

    @Input()
    set floValidIf(value: boolean) {
        if (this.formControl &&
            this._floValidIf !== value) {
            // If the value is changing force a validation check
            this._floValidIf = value;
            this.formControl.updateValueAndValidity();
        } else {
            this._floValidIf = value;
        }
    }

    get floValidIf(): boolean {
        return this._floValidIf;
    }

    public validate(control: FormControl): { [s: string]: boolean } {
        this.formControl = control;

        if (!this.floValidIf) {
            return { invalid: true };
        }

        return null;
    }
}
